<template>
  <v-row>
    <v-col>
      <v-data-table
        id="orders-list-table"
        :loading="loading"
        :headers="headers"
        :items="ordersList"
        :options.sync="pagination"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 75, 100],
        }"
        :items-per-page="perPage"
        item-key="id"
        class="elevation-2 my-6 mx-1 orders-list-table"
      >
        <template v-slot:[`header.customHeader`]="{ header }">
          <!-- Customized header content -->
          <div class="body-1 font-weight-medium text--primary">
            {{ header.text }} ({{ totalItems }})
          </div>
        </template>
        <template v-slot:[`item.customHeader`]="{ item }">
            <order :item="item" class="pa-7 marketing-padding-fix"/>         
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
import { $orders } from "@core/services"
import Order from './Order.vue';
export default {
  components: { Order },
  name: "contact-dashboard-orders",
  props: {
    contactInfo: {
      type: Object,
    }
  },
  data() {
    return {
      ordersList: [],
      headers: [
        { text: "All Orders", sortable: false, value: "customHeader" }
      ],
      perPage: 10,
      page: 1,
      totalItems: 0,
      pagination: {},
      loading: false,
    };
  },
  mounted() {
      this.fetchOrderList()
  },
  watch: {
    pagination: {
      handler(newVal, oldVal) {
        /** prevent this check to invoked function on page load */
        if (oldVal.itemsPerPage) {
          this.fetchOrderList();
        }
      },
      deep: true,
    },
  },
  methods: {
    fetchOrderList () {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination
      const sort = sortDesc.length ? (sortDesc[0] === true ? 'desc' : 'asc') : ''
      const payload = {
        page: page,
        per_page: itemsPerPage,
        email: this.contactInfo.email,
      }
      if (sortBy[0]) { payload.method = sortBy[0] }
      if (sort) { payload.sort_by = sort }
      /**
       * [GET] API call with required payload
       */
      $orders.fetch({
        params: payload,
      }).then(response => {
        const result = response.data.data
        const resultData = []
        if (result.orders.length > 0) {
          result.orders.forEach((order, index) => {
            resultData[index] = order
            resultData[index].showDetail = false
            resultData[index].loading = false
            resultData[index].orderDetail = {}
          })
        }
        this.ordersList = resultData
        this.totalItems = result.meta.count
      }).finally(() => {
        this.loading = false
      })
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
  padding: 0px;
}
</style>
